import { isBrowser } from 'utils/browser';
import { deleteCookie, getListCookie } from 'utils/cookies';
import { uuid } from 'utils/functional/string/uuid';

// Types

export type MainStoreFlashMessagesState = ReadonlyArray<FlashMessageType>;

export type PushAction = {
  type: 'PUSH_FLASH_MESSAGE';
  message: FlashMessageType;
};

export type RemoveAction = {
  type: 'REMOVE_FLASH_MESSAGE';
  id: string;
};

export type ClearAction = {
  type: 'CLEAR_FLASH_MESSAGES';
};

export type MainStoreFlashMessagesAction =
  | PushAction
  | RemoveAction
  | ClearAction;

// Reducer

// need unique ID for React list of messages (using index caused issues)
const getFlashMessageId = () => uuid() + new Date().getTime().toString(36);

const getFlashMessages = (): MainStoreFlashMessagesState => {
  if (isBrowser()) {
    const messages = getListCookie('flashMessages');
    deleteCookie('flashMessages');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return messages.map((message: any) => ({
      ...message,
      id: getFlashMessageId(),
    }));
  }

  return [];
};

const initialState: MainStoreFlashMessagesState = getFlashMessages();

export function flashMessagesReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreFlashMessagesState = initialState,
  action: MainStoreFlashMessagesAction,
): MainStoreFlashMessagesState {
  switch (action.type) {
    case 'PUSH_FLASH_MESSAGE':
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line no-param-reassign
      action.message.id = getFlashMessageId();
      return [...state, action.message];

    case 'REMOVE_FLASH_MESSAGE': {
      const toRemove = action.id;
      return state.filter((m) => m.id !== toRemove);
    }

    case 'CLEAR_FLASH_MESSAGES':
      // remove all messages that aren't sticky
      return [...state.filter((m) => m.sticky)];

    default:
      return state;
  }
}
